import { AppBar, Button, Stack, Toolbar, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Image from 'src/components/image/Image';
import { PATH_AUTH, PATH_SEARCH } from 'src/routes/paths';
import { HEADER } from '../../config-global';

type Props = {
  desktopHeight?: number;
};

// Forked from SearchHeader without "Dodaj swój biznes": guests are invited to
// create an account or sign in instead.
export default function GuestVisitHeader({ desktopHeight }: Props) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <AppBar
      sx={{
        boxShadow: theme.customShadows.z8,
        height: {
          xs: HEADER.H_MOBILE_SEARCH,
          lg: desktopHeight || HEADER.H_MAIN_DESKTOP,
        },
        zIndex: 1300,
        backgroundColor: theme.palette.background.default,
        position: 'fixed',
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          minHeight: {
            sm: HEADER.H_MOBILE_SEARCH,
            md: HEADER.H_MOBILE_SEARCH,
            lg: 1,
          },
          px: { sm: 2, lg: 5 },
        }}
      >
        <Stack justifyContent="center" alignItems="center">
          <Image
            disabledEffect
            visibleByDefault
            alt="Vetsi Logo"
            src={'/assets/logo/logo_dashboard.svg'}
            onClick={() => navigate(PATH_SEARCH.root)}
            sx={{ cursor: 'pointer' }}
            imageSx={{
              width: { xs: '75%', sm: '75%', md: '75%', lg: '100%' },
            }}
          />
        </Stack>
        <Stack
          flexGrow={1}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          spacing={{ xs: 0.5, sm: 1.5 }}
        >
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => navigate(PATH_AUTH.register)}
          >
            {t('header.signUp')}
          </Button>
          <Button
            variant="contained"
            sx={{
              background: theme.palette.common.black,
              color: theme.palette.common.white,
            }}
            onClick={() => navigate(PATH_AUTH.login)}
          >
            {t('header.logIn')}
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
